<template>
    <form class="shaded m-5" @submit.prevent.stop="save" novalidate>
        <div class="row">

            <div class="col-sm-12">
                <div class="form-group" :class="{ error: $v.form.name.$error }">
                    <label class="full">
                        Name
                        <span class="brand">
                            *
                        </span>
                        <input type="text" v-model="form.name" @input="$v.form.name.$touch">
                    </label>

                    <div v-if="$v.form.name.$error" class="messages">
                        <span v-if="!$v.form.name.required">Name is required.</span>
                        <span v-if="!$v.form.name.minLength">Name must have at least 3 characters.</span>
                    </div>
                </div>
            </div>

            <!-- <div class="col-sm-4">
                <div class="form-group">
                    <label class="d-flex align-items-center ml-5 py-4">
                        Active
                        <toggle-button
                            class="ml-3"
                            v-model="form.status"
                            :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </label>
                </div>
            </div> -->
        </div>

        <!-- <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <label class="full">
                        Description
                        <textarea type="text" v-model="form.description"></textarea>
                        <div class="fs-smaller mt-2"></div>
                    </label>
                </div>
            </div>
        </div> -->
    </form>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { required, minLength } from 'vuelidate/lib/validators'

    export default {
        data: function() {
            return {
                form: {
                    name: '',
                },
            }
        },
        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(3),
                },
            }
        },
        created: function() {
            if (this.getSelectedItem) {
                this.form = JSON.parse(JSON.stringify(this.getSelectedItem));
            }
            else {
                this.form.status = true;
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
            ])
        },
        watch: {
            $v: {
                handler: function (n, o) {
                    var toggleIsDisabled = (n.form.$invalid || n.form.$error) ? true : false;

                    this.$emit('toggleIsDisabled', toggleIsDisabled);

                    // Can we save? Have all validations been passed?
                    // Then we'll send the 'actual' form so we can
                    // set it as selectedItem

                    if (!toggleIsDisabled) {
                        this.$emit('readyToSave', this.form);
                    }
                },
                deep: true
            }
        },
    }
</script>



// WEBPACK FOOTER //
// CategoryForm.vue?6830e0cc